<template>
  <div>
    <div class="main_box">
      <!-- <div class="title">订单支付</div> -->
      <div class="pay">
        <div class="payMsg">
          <img src="../assets/images/tick.png" />
          <span class="num" style="margin-top:20px;">{{$t('payOrder.OrderQuantity')}}&#x3000;1</span>
          <span class="num">{{$t('payOrder.NumberProducts')}}&#x3000;{{Number(goodsNum)}}</span>
          <span class="money">￥{{orderInfo.paymentTotal}}</span>
          <span class="explain">
            {{$t('payOrder.PleaseComplete')}}&#x3000;&#x3000;
            <span
              class="highLight"
            >{{getExpireSeconds}}</span>
          </span>
        </div>
        <!-- 购票进度 -->
        <ProgressPanel :activitiesIndex='activitiesIndex'></ProgressPanel>
        <div class="orderInformation">
          <div class="orderInformationBox">
            <h2>
              <span style="color:#ffe7ae;">▎</span>{{$t('payOrder.OrderInformation')}}
            </h2>
            <div class="orderInformationSpan">
              <p style="margin-bottom:10px;color:red;font-size: 16px;font-weight: bold;">{{$t('payOrder.VisitTime') + reservationMsg}}</p>
              <el-table :data="orderInformation" border style="width: 100%">
                <el-table-column prop="ticketName" :label="$t('payOrder.TicketName')" width="180"></el-table-column>
                <el-table-column prop="ticketKindName" :label="$t('payOrder.ticketType')" width="180"></el-table-column>
                <el-table-column prop="salePrice" :label="$t('payOrder.UnitPrice')"></el-table-column>
                <el-table-column :label="$t('payOrder.Quantity')" prop="selectNum"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
        <div class="payWay" v-if="orderInfo.status === '20' && expireSeconds > 0">
          <div class="tit">选择支付方式</div>
          <div class="payment">
            <div v-for="(item,index) in payWayList" :key="index" class="payway-list" @click="handleChange(item, index)">
              <div>
                <input
                  type="radio"
                  name="pay"
                  :value="item.id"
                  :id="item.id"
                  :checked="index === selectPaywayIndex"
                  :key="index"
                />
                <input :value="number" hidden />
                <div class="left-icon" >
                  <div class="left-icon-imagbox">
                    <div class="left-icon-imagbox-item">
                      <img src="../assets/images/zhifubaoIcon.jpg" alt />
                      <p>{{$t('payOrder.Alipay')}}</p>
                    </div>
                    <div class="left-icon-imagbox-item left-icon-imagbox-item2" >
                      <img src="../assets/images/wechatIcon2.png" alt />
                      <p>{{$t('payOrder.WeChat')}}</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="next" v-if="orderInfo.status === '20' && expireSeconds > 0">
          <div class="nextBtn" @click="handleNext" v-if="!loading">立即支付</div>
          <div class="nextBtn" v-else>立即支付</div>
        </div>
        <div v-if="(orderInfo.status !== '20' && orderInfo.status !== '30') || expireSeconds === 0">
          <span class="timeout">
            {{$t('payOrder.Orderpaymenttimeout')}}
            <a class="highLight gobuy" @click="toPath('/')">{{$t('payOrder.goFillOrderL')}}></a>
          </span>
        </div>
      </div>
    </div>
    <!-- 二维码弹窗 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <div class="qrCode" v-if="orderInfo.status === '20' && expireSeconds > 0">
        <div class="img" id="qrcode"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{$t('Cancel')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import CopyRight from '../components/CopyRight'
import QRCode from 'qrcodejs2'
import { payConfirm, checkPay, payWayList, getStaggeredReservationDailyForShow } from '@/api/buyTicket'
import { clearInterval, setInterval } from 'timers'
import ProgressPanel from '../components/ProgressPanel'

export default {
  components: {
    CopyRight,
    ProgressPanel
  },
  data () {
    return {
      goodsNum: 0,
      expireSeconds: null,
      timer: null,
      timer2: null,
      loading: false,
      payWayList: [],
      payConfigId: null,
      orderNo: null,
      orderInfo: {},
      dialogTitle: '请扫码支付',
      dialogVisible: false,
      orderInformation: [],
      reservationMsg: '',
      listOrder: null,
      number: 0,
      activitiesIndex: 4,
      selectPaywayIndex: null
    }
  },
  created () {
    this.isReplenishOrder = this.$route.query.isReplenishOrder || false
    this.orderInformation = JSON.parse(this.$route.query.ticketList)
    this.reservationMsg = this.orderInformation[0] ? this.orderInformation[0].reservationMsg : ''
    this.orderNo = this.$route.query.orderNo
    this.goodsNum = this.$route.query.goodsNum
    this.type = this.$route.query.type || 'spot'
    this.getPayWayList()
    this.getOrderInfo()
    if (this.$route.query.reservationId) {
      getStaggeredReservationDailyForShow({
        staggeredReservationDailyId: this.$route.query.reservationId
      }).then(res =>{
        if (res.code === 0) {
          const data = res.data
          this.reservationMsg = data.reservationDate + ' ' + data.reservationBeginTime + '~' + data.reservationEndTime
        }
      })
    } else {
      this.reservationMsg  = this.$route.query.selectDate
    }
  },
  methods: {
    getOrderInfo () {
      checkPay({ orderNo: this.orderNo }).then(res => {
        if (res.code === 0) {
          this.orderInfo = res.data
          this.expireSeconds = res.data.expireSeconds
          this.timer2 = setInterval(() => {
            if (this.expireSeconds === 0) {
              clearInterval(this.timer2)
            } else {
              --this.expireSeconds
            }
          }, 1000)
        }
      })
    },
    getPayWayList () {
      payWayList().then(res => {
        if (res.code === 0) {
          let index = 0
          this.payWayList = res.data.filter(item => {
            return item.payCatCode === 'QRCODEPAY'
          })
          this.payWayList.map(item => {
            index++
            item.checked = false
            return item
          })
        }
      })
    },
    handleChange (record, index) {
      if (record.payWayCode === 'Weixin') {
        this.dialogTitle = this.$t('payOrder.PleaseQRcodepay') + '(' + this.$t('payOrder.WeChat') + ')'
      } else if (record.payWayCode === 'AliPay') {
        this.dialogTitle = this.$t('payOrder.PleaseQRcodepay') + '(' + this.$t('payOrder.Alipay') + ')'
      } else {
        this.dialogTitle = this.$t('payOrder.PleaseQRcodepay')
      }
      // this.payWayList.forEach(item => {
      //   item.checked = false
      // })
      this.payConfigId = record.id
      // this.payWayList[index].checked = true
      this.selectPaywayIndex = index
    },
    handleNext () {
      if (!this.payConfigId) {
        this.$message({
          message: '请选择支付方式',
          type: 'error'
        })
        return
      }
      this.loading = true
      const param = {
        buyGoodsDetail: this.type === 'ferry' ? '套票交易' : '景区门票交易',
        orderNo: this.orderNo,
        otherParams: {},
        payConfigId: this.payConfigId,
        spbillCreateIp: '127.0.0.0'
      }
      this.dialogVisible = true
      payConfirm(param).then(res => {
        if (res.code === 0) {
          if (this.dialogVisible) {
            const obj = JSON.parse(res.data.payAsyncParams)
            document.getElementById('qrcode').innerHTML = ''
            const qrcode = new QRCode('qrcode', {
              width: 200,
              height: 200,
              text: obj.qrcode || obj.oneQRForAll,
              // 处理二维码文字过长问题
              correctLevel: QRCode.CorrectLevel.Q
            })
          }
          if (this.timer) {
            clearInterval(this.timer)
          }
          this.timer = setInterval(() => {
            checkPay({ orderNo: this.orderNo }).then(r => {
              if (r.code === 0) {
                if (Number(r.data.status) === 30) {
                  this.$router.push({
                    path: '/paySucceed'
                  })
                } else {
                  if (Number(r.data.status) !== 20 || this.expireSeconds === 0) {
                    clearInterval(this.timer)
                    this.$router.push({
                      path: '/payFailed',
                      query: {
                        orderNo: this.orderNo,
                        status: r.data.status
                      }
                    })
                  }
                }
              } else {
                this.$message({
                  message: res.error,
                  type: 'error'
                })
              }
            })
          }, 1000)
        } else {
          this.$message({
            message: res.error,
            type: 'error'
          })
        }
      })
    },
    toPath (path) {
      this.$router.push(path)
    },
    handleClose () {
      this.dialogVisible = false
      this.loading = false
    }
  },
  // filters: {
  //   timeFormat: function (val) {
  //     const M = parseInt(val / 60)
  //     const s = parseInt(val % 60)
  //     return   [(M < 10 ? '0' + M : M) , (s < 10 ? '0' + s : s)]
  //   }
  // },
  computed: {
    getExpireSeconds () {
      const M = parseInt(this.expireSeconds / 60)
      const s = parseInt(this.expireSeconds % 60)
      let t = this.$t('payOrder.PaymentOrderSeconds')
      t = t.replace(new RegExp('&item1'), (M < 10 ? '0' + M : M)).replace(new RegExp('&item2'), (s < 10 ? '0' + s : s))
      return t
    }
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.timer2) {
      clearInterval(this.timer2)
    }
  }
}
</script>

<style lang="scss" scoped>
.orderInformationSpan {
  width: 80%;
  margin: 0 auto;
}
.orderInformation {
  width: 100%;
  margin: 10px 0 30px 0;
}
.orderInformationBox {
  width: 80%;
  margin: 0 auto;
}
.title {
  font-size: 24px;
  line-height: 65px;
  font-weight: bold;
}

.pay {
  position: relative;
  border: 1px solid #ddd;
  margin-bottom: 59px;
  background-color: #fff;
  .schedule {
  position: absolute;
  right: -185px;
  top: 0;
  .title {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 165px;
    height: 40px;
    background: #853D3F;
    color: #FFFFFF;
    font-size: 16px;
    font-family: PingFang SC;
    font-weight: bold;
  }
  .content {
    padding: 16px 16px;
    background: white;
    padding-right: 0;
    .activity {
      color: #853D3F;
    }
  }
}
}

.payMsg {
  position: relative;
  height: 155px;
  padding: 20px 30px;
  box-sizing: border-box;
  border-bottom: 2px solid #241008;
}

.payMsg img {
  float: left;
  margin-right: 15px;
}

.payMsg .num {
  float: left;
  width: 600px;
  font-size: 18px;
  margin: 5px 0;
}

.payMsg .proNum {
  float: left;
  width: 600px;
  font-size: 18px;
}

.payMsg .money {
  position: absolute;
  top: 20px;
  right: 30px;
  font-size: 40px;
  color: #ff6913;
}

.payMsg .explain {
  position: absolute;
  top: 90px;
  right: 30px;
  font-size: 12px;
  font-family: "SimSun";
}

.payWay .tit {
  font-family: "SimSun";
  color: #222;
  padding-left: 18px;
  line-height: 40px;
  background-color: #fafafa;
}

.payment {
  text-align: center;
}

.payment input[type="radio"] {
  width: 18px;
  height: 18px;
  vertical-align: middle;
  margin-right: 10px;
}

.payment label {
  display: inline-block;
  vertical-align: middle;
  margin-right: 40px;
}

.payment label:nth-last-child(1) {
  margin-right: 0px;
}

.Weixin {
  background-image: url(../assets/images/weixin.png);
  width: 147px;
  height: 39px;
}

.AliPay {
  background-image: url(../assets/images/Alipay.png);
  width: 175px;
  height: 41px;
}

.Chinaums {
  background-image: url(../assets/images/Unionpay.png);
  width: 153px;
  height: 33px;
}

.qrCode {
  padding-top: 20px;
  text-align: center;
}

.qrCode .img {
  display: inline-block;
  width: 200px;
  height: 200px;
}

.next {
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #ddd;
  padding: 15px 70px;
  box-sizing: border-box;
  text-align: right;
}

.nextBtn {
  display: inline-block;
  width: 130px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background-color: #A0393E;
  color: #fff;
  font-family: "SimSun";
  font-size: 14px;
  cursor: pointer;
}
.nextBtn:hover {
  opacity: 0.9;
}
.timeout {
  display: inline-block;
  padding: 100px 0;
  text-align: center;
  width: 100%;
}
.gobuy {
  cursor: pointer;
}
.payway-list {
  vertical-align: middle;
  margin-bottom: 70px;
  margin-right: 30px;
  margin-top: 20px;
  display: inline-block;
  min-width: 180px;
  cursor: pointer;
}
.payway-list img {
  display: inline-block;
  width: 220px;
}
.payway-list label {
  border-left: 1px solid #f3f3f3;
  padding-left: 10px;
}
.left-icon {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 60px;
}
.left-icon-imagbox {
  position: absolute;
  width: 156px;
  top: 25px;
  left: 0;
}
.left-icon-imagbox-item {
  display: inline-block;
  margin-right: 8px;
}
.left-icon-imagbox-item p {
  font-size: 10px;
}
.left-icon-imagbox-item2 {
  margin-left: 8px;
}
.left-icon-imagbox-item-left {
  border: 1px solid #f6f6f6;
  height: 20px;
  position: absolute;
  top: 20px;
}
.left-icon img {
  width: 60px;
  height: 60px;
}
</style>
